import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.final');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-final',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.final/view.scss */
/* src/app/portal.kiosk.final/view.scss: no such file or directory */`],
})
export class PortalKioskFinalComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    public bgtarget: any;

    public title: any = {
        '소수서원': 'Sosu-seowon',
        '남계서원': 'Namgye-seowon',
        '옥산서원': 'Oksan-seowon',
        '도산서원': 'Dosan-seowon',
        '필암서원': 'Piram-seowon',
        '도동서원': 'Dodong-seowon',
        '병산서원': 'Byeongsan-seowon',
        '무성서원': 'Museong-seowon',
        '돈암서원': 'Donam-seowon'
    };

    public desc: any = {
        '소수서원': {
            ko: '1543년에 최초로 건립. 건물, 공간의 기본 요소와 제향과 강학 관련 규정을 처음으로 수립하여 서원의 기준이 되었다.',
            en: 'First built in 1543, it established the basic elements of buildings and spaces as well as regulations related to ancestral rites and academic lectures for the first time, setting the standard for seowon.'
        },
        '남계서원': {
            ko: '1552년에 건립. 강학 공간의 뒤에 제향 공간을 배치하고 유식 공간까지 완벽하게 갖춘 전학후묘의 공간배치를 처음으로 보여주었다.',
            en: 'Built in 1552, it was the first to demonstrate the “jeonhak-humyo” layout with the ancestral shrine behind the lecture space, complete with a resting area.'
        },
        '옥산서원': {
            ko: '1572년에 건립. 서원이 교육과 출판·장서의 중심 기구로 기능하게 된 것을 보여주며, 정문에 누마루 건축물을 처음으로 세운 서원이다.',
            en: 'Built in 1572, it shows how seowon came to function as central institutions for education, publishing, and book collections, and was the first seowon to construct an elevated pavilion at the main gate.'
        },
        '도산서원': {
            ko: '1574년에 건립. 사회와 정치에 영향을 많이 미친 서원으로, 서원이 학문과 학파의 중심으로 변화하는 과정을 보여준다.',
            en: 'Built in 1574, it greatly influenced society and politics, illustrating how seowon evolved into centers of scholarship and academic schools.'
        },
        '필암서원': {
            ko: '1590년에 건립. 호남지역의 평탄한 지형에 맞추어 강당과 기숙사가 사당을 바라보도록 건물을 배치하여 예의를 표했다.',
            en: 'Built in 1590, it was designed to show respect by arranging the lecture hall and dormitory to face the shrine, in keeping with the flat terrain of the Honam region.'
        },
        '도동서원': {
            ko: '1605년에 건립. 자연과 조화를 이룬 서원의 특징을 대표한다. 비탈진 지형을 이용해서 낙동강을 바라보게 건물을 세운 건축 배치가 탁월하다.',
            en: 'Built in 1605, it represents the characteristic of seowon in harmony with nature. Its architectural layout is remarkable for utilizing the sloping terrain to face the Nakdong River.'
        },
        '병산서원': {
            ko: '1613년에 건립. 만대루는 서원 누마루 건축 형태의 탁월한 사례이며, 서원의 역할이 교육기관에서 여론 수렴지로 확대되었음을 보여준다.',
            en: 'Built in 1613, Mandaeru is an outstanding example of a raised floor pavilion in a seowon, and it shows how the role of seowon expanded from educational institutions to forums for public opinion.'
        },
        '무성서원': {
            ko: '1615년에 건립. 지역의 학문 부흥과 성리학 전파에 힘쓴 서원이다. 향약의 바탕이 되었으며 20세기 초 항일 의병의 근거지가 되었다.',
            en: 'Built in 1615, this seowon was devoted to the revival of local scholarship and the spread of Neo-Confucianism. It served as the basis for local community compacts and became a stronghold for anti-Japanese militias in the early 20th century.'
        },
        '돈암서원': {
            ko: '1634년에 건립. 성리학의 실천 이론인 예학 논의의 산실이며, 예학을 건축으로 표현한 강학당인 응도당이 탁월하다.',
            en: 'Built in 1634, it was a center for the study of ritual theory in Neo-Confucianism. The Eungdodang lecture hall, which embodies ritual theory in its architecture, is particularly notable.'
        },
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.result = this.event.get("result");
        await this.service.render();
    }

    public url() {
        let bg = this.event.get("bg");
        return wiz.url("result" + bg);
    }

    public async retry() {
        await this.event.view("create");
    }

    public async print() {
        await this.event.view("print");
    }
}

export default PortalKioskFinalComponent;